import styled from "@emotion/styled"
import { Container } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import StarIcon from '@mui/icons-material/Star';
import PeopleIcon from '@mui/icons-material/People';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
export const PositionList = [
    'BAT',
    "BWL",
    "WKP"
]


export const TRIMMEDPOSITIONLIST = [
    'BAT',
    "BWL",
    "WKP"
]

export var TeamsList = {
    'Melbourne Renegades': ['#e5002b','#333'],
    'Sydney Sixers': ['#ea2399','#400526'],
    'Melbourne Stars': ['#00b140','#000000'],
    'Perth Scorchers': ['#e68b00','#e25300'],
    'Brisbane Heat': ['#01a3ae','#333'],
    'Sydney Thunder': ['#97d700','#2e4100'],
    "Adelaide Strikers": ['#0085ca','#333'],
    "Hobart Hurricanes": ['#5f259f','#1d0b30'],
    '': ['#ea2399','#400526'],
}

export var TeamsBGColors = {
    'Broncos': 'transparent',
    'Raiders': 'white',
    'Bulldogs': 'transparent',
    'Sharks': 'transparent',
    'Titans': 'transparent',
    'Eagles': 'white',
    'Sea Eagles': 'transparent',
    'Storm': 'transparent',
    'Knights': 'transparent',
    'Cowboys': 'transparent',
    'Eels': 'white',
    'Panthers': 'white',
    'Rabbitohs': 'white',
    'Dragons': 'white',
    'Roosters': 'white',
    'Warriors': 'transparent',
    'Tigers': 'white',
    'Wests Tigers': 'transparent',
    "Perth Scorchers": 'transparent',
    'Sydney Sixers': 'transparent',
}

export const TeamLogos = {
    'Dragons': 'https://www.nrl.com/Client/dist/logos/dragons-badge.svg?bust=202110292',
    'Titans': 'https://www.nrl.com/Client/dist/logos/titans-badge.svg?bust=202110292',
    'Roosters': 'https://www.nrl.com/Client/dist/logos/roosters-badge.svg?bust=202110292',
    'Broncos': 'https://www.nrl.com/Client/dist/logos/broncos-badge-light.svg?bust=202110292',
    'Knights': 'https://www.nrl.com/Client/dist/logos/knights-badge-light.svg?bust=202110292',
    'Eels': 'https://www.nrl.com/Client/dist/logos/eels-badge.svg?bust=202110292',
    'Panthers': 'https://www.nrl.com/Client/dist/logos/panthers-badge-light.svg?bust=202110292',
    'Sea Eagles': 'https://www.nrl.com/Client/dist/logos/sea-eagles-badge.svg?bust=202110292',
    'Raiders': 'https://www.nrl.com/Client/dist/logos/raiders-badge-light.svg?bust=202110292',
    'Sharks': 'https://www.nrl.com/Client/dist/logos/sharks-badge-light.svg?bust=202110292',
    'Rabbitohs': 'https://www.nrl.com/Client/dist/logos/rabbitohs-badge.svg?bust=202110292',
    'Warriors': 'https://www.nrl.com/Client/dist/logos/warriors-badge-light.svg?bust=202110292',
    'Tigers': 'https://www.nrl.com/Client/dist/logos/wests-tigers-badge-light.svg?bust=202110292',
    'Wests Tigers': 'https://www.nrl.com/Client/dist/logos/wests-tigers-badge-light.svg?bust=202110292',
    'Storm': 'https://www.melbournestorm.com.au/client/dist/logos/storm-badge-light.svg?bust=202202171',
    'Cowboys': 'https://www.nrl.com/Client/dist/logos/cowboys-badge-light.svg?bust=202110292',
    'Bulldogs': 'https://www.nrl.com/Client/dist/logos/bulldogs-badge.svg?bust=202110292',
    'Perth Scorchers': `/images/logos/Perth_Scorchers.svg`,
    'Brisbane Heat': `/images/logos/Brisbane_Heat.svg`,
    'Hobart Hurricanes': `/images/logos/Hobart_Hurricanes.svg`,
    'Melbourne Renegades': `/images/logos/Melbourne_Renegades_White.svg`,
    'Sydney Sixers': `/images/logos/Sydney_Sixers.svg`,
    'Melbourne Stars': `/images/logos/Melbourne_Stars.svg`,
    'Adelaide Strikers': `/images/logos/Adelaide_Strikers.svg`,
    'Sydney Thunder': `/images/logos/Sydney_Thunder.svg`,
}

export const TeamNames = [
    'Perth Scorchers',
    'Brisbane Heat',
    'Hobart Hurricanes',
    'Melbourne Renegades',
    'Sydney Sixers',
    'Melbourne Stars',
    'Adelaide Strikers',
    'Sydney Thunder',
]

export const FILTERITEMS = [
    'points',
    'wickets',
    'runs',
    'dotballs',
    'Bat Strike Rate',
    'Bowl Strike Rate'
]

export const CHARTCOLORS = [
    '#2EB67D', 
    '#36C5F0', 
    '#E01E5A', 
    '#910000', 
    '#ECB22E',
    '#492970', 
    '#f28f43', 
    '#77a1e5', 
    '#c42525', 
    '#a6c96a'
]

export const RankColors = {
    1: '#339900',
    2: '#339900',
    3: '#339900',
    4: '#99cc33',
    5: '#99cc33',
    6: '#99cc33',
    7: '#ffcc00',
    8: '#ffcc00',
    9: '#ffcc00',
    10: '#ff9966',
    11: '#ff9966',
    12: '#ff9966',
    13: '#ff4e08',
    14: '#ff4e08',
    15: '#ff4e08',
    16: '#ff4e08',
}

export const RankText = {
    0:  "0th",
    1:  "1st",
    2:  "2nd",
    3:  "3rd",
    4:  "4th",
    5:  "5th",
    6:  "6th",
    7:  "7th",
    8:  "8th",
    9:  "9th",
    10:  "10th",
    11:  "11th",
    12:  "12th",
    13:  "13th",
    14:  "14th",
    15:  "15th",
    16:  "16th",
}


export const MyContainer = styled(Container)`
    @media (min-width: 600px) {
        
        padding-left: 2rem !important;
        padding-right: 2rem !important;
    }
`;


export const TOOLTIPS = {
    'PTS': 'Supercoach points scored',
    'PPM': "Points per minute",
    'BE': "Amount of points needed to justify price",
    '3RA': "Average points scored for last 3 rounds",
    'Mins': "Average minutes played",
    "Base": "(Runs + Tackles) - Missed Tackles",
    "Ownership": "Total Ownership",
    'Minutes': "Average minutes played",
    '3/5rd Avg': "3 round average, 5 round average points scored",
    'Price': "Price of player now (change in price)",
    'SR-BAT': "Batting Strike Rate",
    'Runs-BAT': "Runs Hit",
    'Balls-BAT': "Balls Faced",
    'Balls-BWL': "Balls Bowled",
    'Wickets-BWL': "Wickets Taken",
    "6's-BWL": "6's Conceeded",
    "6's-BAT": "6's Hit",
    "4's-BAT": "4's Hit",
    "4's-BWL": "4's Conceeded",
    "Wides-BWL": "Wides Bowled",
    "Out?-BAT": "Did the player get out?",
    "Dots-BWL": "Dot balls bowled",
    'BE-BAT': "Amount of points needed to justify price",
    'BE-BWL': "Amount of points needed to justify price",
    "SC Avg-BWL": "AVG SC Points",
    "SC Avg-BAT": "AVG SC Points",
    "SR-BWL": "Bowling Strike Rate",
    "AVG Eco-BWL": "Bowling Economy",
    "Eco-BWL": "Bowling Economy",
    '20+-BAT': "Games With +20 Runs",
    'AVG Runs-BAT': "Average runs hit",
    'Games-BAT': "Games played last season",
    'Games-BWL': "Games played last season",
    'AVG ECO-BWL': "Average balls/runs",
    'AVG Dots-BWL': "Average dot balls balled per game",
    'BWL Avg-BWL': "Average runs/wickets last season",
    'SC AVG (BBL11)': "Average SC Points over BBL11 (2021-22)",
    'Overall Rank': "Player's rank of total points this season",
    'SC AVG (BBL10)': "Average SC Points over BBL10 (2020-21)",
    'Breakeven': "Amount of points needed to justify price"
}

export function get_suffix(i:number) {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
}

export const CardStats = [
    { label: "PTS", tooltip: 'Points scored', access: 'points'},
    { label: "3RA", tooltip: 'AVG points scored over 3 rounds', access: 'threeRoundAverage'},
    { label: "5RA", tooltip: 'AVG points scored over 5 rounds', access: 'fiveRoundAverage'}
]

export const ContainerIcons = {
    'Money Makers': AttachMoneyIcon,
    'Captains': StarIcon,
    'SC Teams': StarIcon,
    "Captain": StarIcon,
    "PartnerShips": PeopleIcon,
    "In": AddIcon,
    "Out": RemoveIcon,
    "": <div></div>,
    
}